import { render } from "./ModalCreaPresenza.vue?vue&type=template&id=27c60b3f&scoped=true"
import script from "./ModalCreaPresenza.vue?vue&type=script&lang=js"
export * from "./ModalCreaPresenza.vue?vue&type=script&lang=js"

import "./ModalCreaPresenza.vue?vue&type=style&index=0&id=27c60b3f&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c60b3f"]])

export default __exports__